// src/Lexapp/firebaseService.js
import { db } from '../firebase';
import { collection, getDocs, addDoc } from 'firebase/firestore';

const appsCollection = collection(db, 'apps');

// fetch existing apps
export async function fetchLexApps() {
  const snapshot = await getDocs(appsCollection);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

// add a new app
export async function addLexApp(appData) {
  const ref = await addDoc(appsCollection, appData);
  return ref.id;
}
